import { render, staticRenderFns } from "./ControllerApp.vue?vue&type=template&id=755c5481&"
import script from "./ControllerApp.vue?vue&type=script&lang=js&"
export * from "./ControllerApp.vue?vue&type=script&lang=js&"
import style0 from "./ControllerApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports